import { createFileRoute } from "@tanstack/react-router";
import { CreateRestaurantPage } from "../../features/restaurants/create-page";

export const Route = createFileRoute("/restaurants/new")({ component: CreateRestaurantPage });
